<div class="max-tablet:flex-col w-full flex gap-3 rounded-lg">
	<div class="flex-col w-[50%] max-tablet:w-full">
		<div
			*ngIf="orderDetails?.orderStatus !== 1"
			class="custom-accordion mb-[10px]"
		>
			<mat-accordion>
				<mat-expansion-panel class="mat-elevation-z0">
					<mat-expansion-panel-header>
						<mat-panel-title>
							<div>
								<p class="text-font-18 text-dark-grey m-0">
									{{ 'STORE.ORDER_DETAILS.STATUS_HISTORY' | translate }}
								</p>
								<p class="text-font-16 text-medium-gray m-0">
									{{ orderDetails?.statusHistory?.length }}
									{{ 'GENERAL_LABELS.STATUS' | translate }}
								</p>
							</div>
						</mat-panel-title>
					</mat-expansion-panel-header>
					<div *ngFor="let statusHistory of orderDetails?.statusHistory">
						<div
							class="w-full h-[1px] bg-secondry-color-Gray m-auto mb-8px"
						></div>
						<div class="py-8px flex justify-between">
							<div class="flex">
								<div>
									<img
										class="mt-[3px] mx-16px max-w-[25px]"
										[src]="statusHistoryImage(statusHistory.orderStatus)"
										alt=""
									/>
								</div>
								<div>
									<h1 class="text-dark-grey text-font-16 m-0">
										{{ statusHistory?.date | date : 'dd/MM/yyyy' : 'UTC' }}
									</h1>
									<p class="text-medium-gray text-font-14 m-0">
										{{ statusHistory?.date | date : 'hh:mm a' : 'UTC' }}
									</p>
									<p
										*ngIf="statusHistory?.reason"
										class="text-medium-gray text-font-14 m-0"
									>
										{{ statusHistory?.reason }}
									</p>
								</div>
							</div>
							<div>
								<app-status
									[enumData]="orderDeliverStatus"
									[statusValue]="statusHistory?.orderStatus"
								></app-status>
							</div>
						</div>
					</div>
				</mat-expansion-panel>
			</mat-accordion>
		</div>
		<div
			class="flex flex-col text-dark-grey bg-off-white px-6 pb-3 rounded-lg mb-3"
		>
			<div class="border-b-2 pt-5 flex justify-between items-center">
				<p
					class="text-font-18 mt-3 text-main-color-black ltr:font-DIN-Bold font-bold rtl:font-medium"
				>
					{{ 'STORE.ORDER_DETAILS.ORDER_INFORMATION' | translate }}
				</p>

				<app-status
					[enumData]="orderDeliverStatus"
					[statusValue]="orderDetails?.orderStatus"
				></app-status>
			</div>
			<div class="pt-12px flex">
				<p class="w-[50%]">
					{{ 'STORE.ORDER_DETAILS.ORDER_NUMBER' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%] text-end">
					#{{ orderDetails?.serialNumber }}
				</p>
			</div>

			<div class="flex">
				<p class="w-[50%]">
					{{ 'GENERAL_LABELS.DATE' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%] text-end">
					{{ orderDetails?.date | date : 'dd/MM/yyyy' : 'UTC' }}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{ 'GENERAL_LABELS.TIME' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%] text-end">
					{{ orderDetails?.date | date : 'hh:mm a' : 'UTC' }}
				</p>
			</div>
		</div>
		<div
			class="flex flex-col text-dark-grey bg-off-white px-6 pb-3 rounded-lg mb-3 min-h-[300px]"
		>
			<div class="border-b-2 pt-5 flex justify-between items-center pb-12px">
				<p
					class="text-font-18 mt-5 text-main-color-black ltr:font-DIN-Bold font-bold rtl:font-medium"
				>
					{{ 'STORE.ORDER_DETAILS.CLIENT_INFORMATION' | translate }}
				</p>
				<button
					[routerLink]="
						'/layout/clients/client-profile/' +
						orderDetails?.orderClientDetails?.clientId
					"
					class="border border-solid border-secondry-color-Gray text-dark-grey hover:bg-gradient hover:text-off-white rounded-lg max-mobile:text-[12px] max-mobile:px-padding-mobile-14 max-mobile:py-[7px] py-[15px] px-24px"
				>
					{{ 'STORE.ORDER_DETAILS.VIEW_PROFILE' | translate }}
				</button>
			</div>
			<div class="pt-12px flex">
				<p class="w-[50%] mb-0">
					{{ 'STORE.ORDER_DETAILS.CLIENT_NAME' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%] mb-0 text-end">
					{{ orderDetails?.orderClientDetails?.clientName }}
				</p>
			</div>
			<div class="pt-12px flex justify-between">
				<p class="w-[50%] mb-0">
					{{ 'STORE.ORDER_DETAILS.PHONE_NUMBER' | translate }}
				</p>
				<div
					*ngIf="orderDetails?.orderClientDetails?.clientPhoneNumber"
					class="flex justify-between"
				>
					<p class="text-medium-gray text-font-12 mx-1 mb-0 text-end">
						{{ orderDetails?.orderClientDetails?.clientPhoneNumber }}
					</p>
					<span *ngIf="orderDetails?.orderClientDetails?.isClientPhoneVerified"
						><img src="./assets/images/verify.svg" alt=""
					/></span>
					<span
						*ngIf="!orderDetails?.orderClientDetails?.isClientPhoneVerified"
					>
						<img
							[src]="'assets/images/not-verified.svg'"
							alt=""
							class="inline-block cursor-pointer"
						/>
					</span>
				</div>
			</div>
			<div class="pt-12px mb-12px flex justify-between">
				<p class="w-[50%] mb-0">
					{{ 'GENERAL_LABELS.EMAIL' | translate }}
				</p>
				<div class="flex justify-between">
					<p class="text-medium-gray text-font-12 mx-1 mb-0 text-end">
						{{ orderDetails?.orderClientDetails?.clientEmail }}
					</p>
					<span *ngIf="orderDetails?.orderClientDetails?.isClientEmailVerified"
						><img src="./assets/images/verify.svg" alt=""
					/></span>
					<span
						*ngIf="!orderDetails?.orderClientDetails?.isClientEmailVerified"
					>
						<img
							[src]="'assets/images/not-verified.svg'"
							alt=""
							class="inline-block cursor-pointer"
						/>
					</span>
				</div>
			</div>
			<div class="flex mb-12px">
				<p class="w-[50%] mb-0">
					{{ 'GENERAL_LABELS.CITY_AREA' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%] mb-0 text-end">
					{{
						translate.currentLang == 'en'
							? orderDetails?.orderAddress?.city?.en
							: orderDetails?.orderAddress?.city?.ar
					}}
					|
					{{
						translate.currentLang == 'en'
							? orderDetails?.orderAddress?.district?.en
							: orderDetails?.orderAddress?.district?.ar
					}}
				</p>
			</div>
			<div class="flex mb-12px">
				<p class="w-[50%] mb-0">
					{{ 'GENERAL_LABELS.ADDRESS' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%] mb-0 text-end">
					{{ orderDetails?.orderAddress?.address }}
				</p>
			</div>
		</div>
	</div>

	<div class="flex-col w-[50%] max-tablet:w-full">
		<div class="custom-accordion mb-12px">
			<mat-accordion>
				<mat-expansion-panel class="mat-elevation-z0">
					<mat-expansion-panel-header>
						<mat-panel-title>
							<div>
								<p class="text-font-18 text-dark-grey m-0">
									{{ 'STORE.ORDER_DETAILS.ORDER_SUMMARY' | translate }}
								</p>
								<p class="text-font-16 text-medium-gray m-0">
									{{ orderDetails?.productDetails?.length }}
									{{
										orderDetails?.productDetails?.length
											? orderDetails.productDetails.length > 1
												? ('STORE.ORDER_DETAILS.PRODUCTS' | translate)
												: ('STORE.ORDER_DETAILS.PRODUCT' | translate)
											: ''
									}}
								</p>
							</div>
						</mat-panel-title>
					</mat-expansion-panel-header>
					<div *ngFor="let product of orderDetails?.productDetails">
						<div
							class="w-full h-[1px] bg-secondry-color-Gray m-auto mb-8px"
						></div>
						<div class="py-8px flex justify-between">
							<div class="flex gap-x-[12px]">
								<img
									class="rounded-full w-[48px] h-[48px]"
									[src]="attachmentLink + product?.imageUrl"
									alt=""
								/>

								<div class="w-[85%]">
									<h1 class="text-dark-grey text-font-16 m-0 break-all">
										{{
											translate.currentLang == 'en'
												? product?.productName?.en
												: product?.productName?.ar
										}}
										{{
											translate.currentLang == 'en'
												? product?.productVariantName?.en
												: product?.productVariantName?.ar
										}}
									</h1>
									<p class="text-medium-gray text-font-14 m-0">
										{{ product?.count }}
										{{
											product?.count
												? product.count > 1
													? ('STORE.ORDER_DETAILS.ITEMS' | translate)
													: ('STORE.ORDER_DETAILS.ITEM' | translate)
												: ''
										}}
									</p>
								</div>
							</div>
							<div>
								<h1
									*ngIf="product?.price"
									class="text-medium-gray text-font-16 m-0 break-normal whitespace-nowrap"
								>
									{{ product?.price }}
									{{
										translate?.currentLang == 'en'
											? product?.currency?.name?.en
											: product?.currency?.name?.ar
									}}
								</h1>
								<h1
									*ngIf="product?.priceBeforeDiscount"
									class="text-dark-grey text-font-16 m-0 break-normal whitespace-nowrap {{
										product?.price ? 'line-through' : ''
									}}"
								>
									{{ product?.priceBeforeDiscount }}
									{{
										translate?.currentLang == 'en'
											? product?.currency?.name?.en
											: product?.currency?.name?.ar
									}}
								</h1>
							</div>
						</div>
					</div>
				</mat-expansion-panel>
			</mat-accordion>
		</div>
		<div
			class="flex flex-col text-dark-grey bg-off-white px-6 pb-3 rounded-lg mb-3"
		>
			<div class="border-b-2 pt-5 mb-4 flex justify-between">
				<p
					class="text-font-18 mt-3 text-dark-grey ltr:font-DIN-Bold font-bold rtl:font-medium"
				>
					{{ 'STORE.ORDER_DETAILS.DELIVERY_NOTES' | translate }}
				</p>
			</div>
			<div class="flex flex-col gap-4">
				<div>
					<p class="text-16 text-dark-grey font-Poppins-regular">
						{{ orderDetails?.deliveryNotes }}
					</p>
				</div>
			</div>
		</div>

		<div class="flex flex-col text-dark-grey bg-off-white px-6 rounded-lg mb-3">
			<div class="border-b-2 pt-5 flex justify-between">
				<p
					class="text-font-18 mt-3 text-dark-grey ltr:font-DIN-Bold font-bold rtl:font-medium"
				>
					{{ 'STORE.ORDER_DETAILS.PAYMENT_INFO' | translate }}
				</p>

				<app-status
					[enumData]="orderPaymentEnum"
					[statusValue]="orderDetails?.orderPayment?.paymentStatus"
				></app-status>
			</div>
			<p
				class="text-font-16 mt-5 text-[#4E4B66] ltr:font-DIN-Bold font-bold rtl:font-medium"
			>
				{{ 'STORE.ORDER_DETAILS.PAYMENT_DETAILS' | translate }}
			</p>

			<div class="mb-10">
				<div
					*ngIf="orderDetails?.orderPayment?.subTotal"
					class="flex justify-between relative text-[#6E7191] items-center"
				>
					<p class="m-0">
						{{ 'STORE.ORDER_DETAILS.SUBTOTAL' | translate }}
					</p>
					<p class="m-2">
						{{
							translate.currentLang == 'en'
								? orderDetails?.orderPayment?.currency?.name?.en
								: orderDetails?.orderPayment?.currency?.name?.ar
						}}
						{{ orderDetails?.orderPayment?.subTotal }}
					</p>
				</div>
				<div
					*ngIf="orderDetails?.orderPayment?.shippingFees"
					class="flex justify-between relative text-[#6E7191] items-center"
				>
					<p class="m-0">
						{{ 'STORE.ORDER_DETAILS.SHIPPING_FEES' | translate }}
					</p>
					<p class="m-2">
						{{
							translate.currentLang == 'en'
								? orderDetails?.orderPayment?.currency?.name?.en
								: orderDetails?.orderPayment?.currency?.name?.ar
						}}{{ orderDetails?.orderPayment?.shippingFees }}
					</p>
				</div>


				<div
					*ngIf="orderDetails?.orderPayment?.walletAmount"
					class="flex justify-between relative text-[#6E7191] items-center"
				>
					<p class="m-0">
						{{ 'STORE.ORDER_DETAILS.WALLET_AMOUNT' | translate }}
					</p>
					<p class="m-2">
						{{
							translate.currentLang == 'en'
								? orderDetails?.orderPayment?.currency?.name?.en
								: orderDetails?.orderPayment?.currency?.name?.ar
						}}{{ orderDetails?.orderPayment?.walletAmount }}
					</p>
				</div>

				<div
					*ngIf="orderDetails?.orderPayment?.pointsAmount"
					class="flex justify-between relative text-[#6E7191] items-center"
				>
					<p class="m-0">
						{{ 'STORE.ORDER_DETAILS.POINTS_AMOUNT' | translate }}({{orderDetails?.orderPayment?.redeemedPoints}})
					</p>
					<p class="m-2">
						{{
							translate.currentLang == 'en'
								? orderDetails?.orderPayment?.currency?.name?.en
								: orderDetails?.orderPayment?.currency?.name?.ar
						}}{{ orderDetails?.orderPayment?.pointsAmount }}
					</p>
				</div>



				<div
					*ngIf="orderDetails?.promoCodeDetails"
					class="flex justify-between relative text-[#6E7191] items-center"
				>
					<p class="m-0">
						{{ 'STORE.ORDER_DETAILS.PROMO_CODE' | translate }}
						({{ orderDetails?.promoCodeDetails?.promoCode }})
					</p>
					<p class="m-2">
						-{{ orderDetails?.promoCodeDetails?.promoCodeDiscount }}
					</p>
				</div>
				<div
					*ngIf="orderDetails?.orderPayment?.totalDiscount"
					class="flex justify-between relative text-[#6E7191] items-center"
				>
					<p class="m-0">
						{{ 'STORE.ORDER_DETAILS.DISCOUNT' | translate }}
					</p>
					<p class="m-2">
						{{
							translate.currentLang == 'en'
								? orderDetails?.orderPayment?.currency?.name?.en
								: orderDetails?.orderPayment?.currency?.name?.ar
						}}
						{{ orderDetails?.orderPayment?.totalDiscount }}
					</p>
				</div>

				<div
					*ngIf="orderDetails?.orderPayment?.total"
					class="flex justify-between relative items-center"
				>
					<p class="m-0 text-font-14 text-[#4E4B66]">
						{{ 'STORE.ORDER_DETAILS.TOTAL' | translate }}
					</p>
					<p class="m-2 text-font-16 text-gradient">
						{{
							translate.currentLang == 'en'
								? orderDetails?.orderPayment?.currency?.name?.en
								: orderDetails?.orderPayment?.currency?.name?.ar
						}}
						{{ orderDetails?.orderPayment?.total }}
					</p>
				</div>
			</div>

			<div class="bg-[#EFF0F6] p-5 rounded-md">
				<div class="flex justify-between font-DIN-bold font-bold">
					<p class="mb-0 text-font-18 text-dark-grey">
						{{ 'STORE.ORDER_DETAILS.PAYMENT_METHOD' | translate }}
					</p>
					<div>
						<img
							[src]="
								orderDetails?.orderPayment?.paymentMethod?.id == 0
									? 'assets/images/Cash.svg'
									: orderDetails?.orderPayment?.paymentMethod?.id == 1
									? 'assets/images/card.svg'
									: orderDetails?.orderPayment?.paymentMethod?.id == 2
									? 'assets/images/pay2.svg'
									: 'assets/images/pay3.svg'
							"
							alt=""
							class="inline-block w-[25px]"
						/>
						<p
							class="inline-block font-Poppins-regular text-medium-gray max-mobile:ltr:ml-1 max-mobile:rtl:mr-1 ltr:ml-3 rtl:mr-1"
						>
							{{
								this.translate.currentLang == 'en'
									? orderDetails?.orderPayment?.paymentMethod?.nameEn
									: orderDetails?.orderPayment?.paymentMethod?.nameAr
							}}
						</p>
					</div>
				</div>
			</div>

			<div class="flex my-24px">
				<button
					*ngIf="
						orderDetails?.orderStatus
							? orderDetails.orderStatus <= 4 && orderDetails.orderStatus !== 7
							: null
					"
					(click)="cancelAction()"
					class="py-[15px] mx-12px text-dark-grey border-secondry-color-Gray border-[1px] w-1/4 rounded-6px"
				>
					{{ 'STORE.ORDER_DETAILS.CANCEL_ORDER' | translate }}
				</button>
				<button
					*ngIf="
						orderDetails?.orderStatus
							? orderDetails?.targetedStatuses
								? orderDetails.targetedStatuses.length > 0
								: null
							: null
					"
					(click)="updateStatus()"
					class="py-[15px] {{
						orderDetails?.orderStatus
							? orderDetails.orderStatus < 4 && orderDetails.orderStatus !== 7
								? 'w-3/4'
								: 'w-full'
							: null
					}} bg-gradient rounded-6px text-off-white"
				>
					{{ 'STORE.ORDER_DETAILS.UPDATE_ORDER_STATUS' | translate }}
				</button>
			</div>
			<div
				*ngIf="orderDetails?.pointsDetails?.isHoldedTakenPoints"
				class="w-full rounded-[4px] bg-[#E2F5EE] py-8px flex items-center justify-center"
			>
				<img src="./assets/images/coin.svg" alt="" />
				<h1 class="m-0 text-font-14 text-success-green">
					{{
						'STORE.ORDER_DETAILS.PENDING_POINTS'
							| translate : { POINTS: orderDetails.pointsDetails.takenPoints }
					}}
				</h1>
			</div>
			<!-- <div
				*ngIf="orderDetails?.pointsDetails?.usedPoints"
				class="w-full rounded-[4px] bg-[#e5cac9] py-8px flex items-center justify-center"
			>
				<img src="./assets/images/coin-red.svg" alt="" />
				<h1 class="m-0 text-font-14 text-red-error">
					{{
						'STORE.ORDER_DETAILS.DEDUCTED_POINTS'
							| translate : { POINTS: orderDetails.pointsDetails.usedPoints }
					}}
				</h1>
			</div> -->
		</div>
	</div>
</div>
